<template>
  <div id="pageItemList">
    <page-header :title="$t('comprehensiveReport')"></page-header>
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg12>
          <v-card>
            <v-card-text>
              <v-form ref="editCreateForm">
                <v-container grid-list-md fluid>
                  <v-layout wrap justify-space-between>
                    <v-flex xs8>
                      <v-autocomplete
                        name="vehicles"
                        :label="$t('vehicle')"
                        :loading="vehicleIsLoading"
                        :items="vehicles"
                        :search-input.sync="vehicleSearch"
                        v-model="reportParams.vehicles"
                        cache-items
                        clearable
                        prepend-icon="train"
                        item-text="name"
                        item-value="id"
                        v-validate="'required'"
                        :data-vv-as="$t('vehicle')"
                        :error-messages="errors.collect('vehicles')"
                        multiple
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex xs2>
                      <v-menu
                        :close-on-content-click="false"
                        v-model="date.fromMenu"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                      >
                        <v-text-field
                          name="date_from"
                          slot="activator"
                          :value="
                            reportParams.dateFrom
                              ? $moment(reportParams.dateFrom).format('LL')
                              : null
                          "
                          :label="$t('dateFrom')"
                          v-validate="'required'"
                          :data-vv-as="$t('dateFrom')"
                          :error-messages="errors.collect('date_from')"
                          readonly
                        ></v-text-field>
                        <v-date-picker
                          v-model="reportParams.dateFrom"
                          @input="date.fromMenu = false"
                          :locale="LANG"
                          reactive
                          :max="$moment().format('YYYY-MM-DD')"
                        ></v-date-picker>
                      </v-menu>
                    </v-flex>
                    <v-flex xs2>
                      <v-menu
                        :close-on-content-click="false"
                        v-model="date.untilMenu"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                      >
                        <v-text-field
                          name="date_until"
                          slot="activator"
                          :value="
                            reportParams.dateUntil
                              ? $moment(reportParams.dateUntil).format('LL')
                              : null
                          "
                          :label="$t('dateUntil')"
                          v-validate="'required'"
                          :data-vv-as="$t('dateUntil')"
                          :error-messages="errors.collect('date_until')"
                          readonly
                        ></v-text-field>
                        <v-date-picker
                          v-model="reportParams.dateUntil"
                          @input="date.untilMenu = false"
                          :locale="LANG"
                          reactive
                          :max="$moment().format('YYYY-MM-DD')"
                        ></v-date-picker>
                      </v-menu>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                :href="getDownloadUrl"
                :disabled="!formIsReady"
                target="_blank"
                color="success"
              >
                {{ $t("download") }}
                <v-icon right>save_alt</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import _ from "lodash";
import { FETCH_VEHICLES, RESET_REPORT } from "@/store/actions.type";
import JwtService from "../../common/jwt.service";
import store from "@/store";

export default {
  data() {
    return {
      date: {
        fromMenu: false,
        untilMenu: false
      },
      vehicleSearch: "",
      reportParams: {
        vehicles: [],
        dateFrom: null,
        dateUntil: null
      },
      LANG: process.env.VUE_APP_LANG
    };
  },
  computed: {
    ...mapGetters(["vehicles", "vehicleIsLoading"]),
    getDownloadUrl() {
      return (
        process.env.VUE_APP_API_URL +
        "/report/comprehensive/file?dateFrom=" +
        this.reportParams.dateFrom +
        "&dateUntil=" +
        this.reportParams.dateUntil +
        "&vehicles[]=" +
        this.reportParams.vehicles.join("&vehicles[]=") +
        "&bearer=" +
        JwtService.getToken()
      );
    },
    formIsReady() {
      return (
        !!this.reportParams.vehicles.length &&
        this.reportParams.dateFrom &&
        this.reportParams.dateUntil
      );
    }
  },
  watch: {
    vehicleSearch: _.debounce(function(val) {
      this.$store.dispatch(FETCH_VEHICLES, [{ rowsPerPage: -1 }, val]);
    }, 300)
  },
  beforeRouteEnter(to, from, next) {
    Promise.all([store.dispatch(RESET_REPORT)]).then(() => {
      next();
    });
  }
};
</script>

<style scoped></style>
